import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { CloseCrossCircle } from '../../icons';
import { Typography } from '../Typography';
import styles from './MultiAutocomplete.module.scss';
export function MultiAutocompleteChip(param) {
    let { label, onRemove, testId } = param;
    const handleRemove = (event)=>{
        event.stopPropagation();
        onRemove();
    };
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        className: styles.designChip,
        "aria-label": label,
        onClick: handleRemove,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                weight: "light",
                className: styles.designChipLabel,
                children: label
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.designChipClose,
                children: /*#__PURE__*/ _jsx(CloseCrossCircle, {
                    size: 16
                })
            })
        ]
    });
}
